import script from "./Balance.vue?vue&type=script&setup=true&lang=ts"
export * from "./Balance.vue?vue&type=script&setup=true&lang=ts"

import "./Balance.vue?vue&type=style&index=0&id=dff64a3e&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dff64a3e"]])

export default __exports__